import { Fragment, useEffect, useMemo, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import InfiniteScrollGrid from "../../../UI/infinite-scroll-grid";
import { processServices } from "../../../../services/InspectionOneServices";
import {
  DownloadRenderer,
  ExportRenderer,
  ImageNameCellRenderer,
  InfoRenderer,
  MoreOptionsRenderer,
  NameCellRenderer,
  StatusNameCellRenderer,
} from "../../../UI/grid-cells";
import IconBtn from "../../../form/icon-btn";
import { DeleteIcon } from "../../../svg";

function ProcessGrid({
  selectedColumns,
  rowSelection,
  moreOptions,
  handleNavigate,
  handleEdit,
  handleDelete,
  rowData,
  scrollGroundRef,
  handleScroll,
  initialLoading,
  isLoading,
  limit,
  finalFetch,
  sorting,
  sortingColumnName,
  handleSort,
  handleCheckboxChange,
  handleOpenMoreInfo,
  noDataFound,
  siteConfigDetails,
  setIsLoading,
  setShowDeletePopup,
  setDeleteData
}: any) {
  const [columnDefs, setColumnDefs] = useState<any>([]);
  const handleCellClicked = (params: any) => {
    handleNavigate(params);
  };

  const handleExportClick = async (rowData: any) => {
    try {
      const requestJson = {
        id: rowData.id,
        processLogicId: rowData.processLogicId,
        subProcessLogicId: rowData.subProcessLogicId,
      };
      const response: any = await processServices.ProcessExportAction(
        requestJson
      );
      const link = document.createElement("a");
      link.href = response.data;
      link.setAttribute("download", "exported_file_name.extension");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) { }
  };

  const handleDownloadClick = async (rowData: any) => {
    try {
      setIsLoading(true);
      const parsedDetails = JSON.parse(siteConfigDetails.reportDetails);
      const requestJson = {
        filterValue: rowData.subTitle[0],
        masterAccessId: parsedDetails?.masterAccessId
          ? parsedDetails?.masterAccessId
          : ""
      };
      const response: any = await processServices.PdfGenerate(
        requestJson
      );
      if (response.success) {
        setIsLoading(false);
        const link = document.createElement("a");
        link.href = response.data.responseResult.bloburl;
        link.setAttribute("download", "exported_file_name.extension");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
      setIsLoading(false);
    } catch (error) { setIsLoading(false); }
  };

  const parsedReportDetails = useMemo(() => {
    try {
      return JSON.parse(siteConfigDetails.reportDetails)
    } catch {
      return {};
    }
  }, [siteConfigDetails]);

  const columnRemovalKey = parsedReportDetails?.columnRemovalKey ?? [];
  const isVerifiedRequired = parsedReportDetails?.isVerifiedRequired ? 1 : 0;
  const isDeleteOption = parsedReportDetails?.isProcessDelete ? 1 : 0;
  const mode1Fields = ["processName", "processLogic", "subProcessLogic", "inspectedBy", "createdDate", "verifiedBy", "verificationStatus"];
  const mode2Fields = ["processName", "subTitle", "processLogic", "surveyName", "inspectedBy", "createdDate", "verifiedBy", "verifiedDate", "verificationStatus"];

  if (isDeleteOption == 1) {

  }

  const getFilteredColumns = (mode: any) => {
    let hideFields = mode == 1 ? mode1Fields : mode == 2 ? mode2Fields : [];
    if (columnRemovalKey.length > 0) {
      hideFields = hideFields.filter((field: string) => !columnRemovalKey.includes(field));
    }
    const data = [
      {
        headerName: "Process Name",
        token: parsedReportDetails?.processAliasName ? "web.process.label.modelName" : "web.process.label.name",
        field: "processName",
        width: "flex-1",
        align: "left",
      },
      {
        headerName: "Sub Title",
        token: "web.process.label.subTitle",
        field: "subTitle",
        width: "flex-1",
        align: "left",
      },
      {
        headerName: "Logic Name",
        token: "web.logic.label.name",
        field: "processLogic",
        width: "flex-1",
        align: "left",
      },
      {
        headerName: "Screen Mapping Name",
        token: "web.screenmapping.label.name",
        field: "subProcessLogic",
        width: "flex-1",
        align: "left",
      },
      {
        headerName: "Screen Collection",
        token: "web.screen.label.name",
        field: "surveyName",
        width: "flex-1",
        align: "left",
      },
      {
        headerName: "Inspected by",
        token: parsedReportDetails?.inspectedByAliasName ? "web.common.label.setter" : "web.common.label.inspectedby",
        field: "inspectedBy",
        width: "flex-1",
        align: "left",
      },
      {
        headerName: "Created Date",
        token: "web.common.label.createddate",
        field: "createdDate",
        width: "flex-1",
        align: "left",
      },
      ...(isVerifiedRequired === 1
        ? [
          {
            headerName: "Verified By",
            token: "web.common.label.verifiedBy",
            field: "verifiedBy",
            width: "flex-1",
            align: "left",
          },
          {
            headerName: "Verified At",
            token: "web.common.label.verifiedAt",
            field: "verifiedDate",
            width: "flex-1",
            align: "left",
          },
        ]
        : []),
      {
        headerName: "Verification Status",
        token: "web.common.label.verificationstatus",
        field: "verificationStatus",
        width: "flex-1",
        align: "left",
      },
    ];
    return data.filter((col: any) => hideFields.includes(col.field));
  };

  useEffect(() => {
    if (siteConfigDetails) {
      var dataset = getFilteredColumns(siteConfigDetails.mode); 
      setColumnDefs(dataset);
    }
  }, [siteConfigDetails])


   useEffect(() => {
    
      console.log("rowData", rowData);
     
     }, [rowData])

  const canRender = (cellKey: string) => {
    if (!columnRemovalKey || columnRemovalKey.length === 0) {
      return true;
    }
    return (
      columnDefs.some((col: { field: string; }) => col.field === cellKey) &&
      !parsedReportDetails?.columnRemovalKey.includes(cellKey)
    );
  };

  const selectedMoreOption = (option: string, row: any) => {
    if (option === "edit") {
      // navigate("/master-details/new-master-details/" + row.uniqueId);
    } else if (option === "delete") {
      handleDelete(row);
    }
  };

  return (
    <>
      <div className="w-full h-full">
        <InfiniteScrollGrid
          columnDefs={columnDefs}
          rowData={rowData}
          initialLoading={initialLoading}
          searchedQuery=""
          handleScroll={handleScroll}
          chatGroundRef={scrollGroundRef}
          selectedColumns={selectedColumns}
          isLoading={isLoading}
          finalFetch={finalFetch}
          rowSelection={rowSelection}
          moreOptions={moreOptions}
          handleSort={handleSort}
          sorting={sorting}
          sortingColumnName={sortingColumnName}
          noDataFound={noDataFound}
        >
          {rowData?.map((rowData: any, i: number) => (
            <Fragment key={i}>
              <tr className="w-full h-auto flex justify-between p-[0.65rem] border-b border-[#EDEDED] dark:border-[#BDBDBF] hover:bg-[#eff8ff] dark:hover:bg-[#112A46]">
                {/* <RowSelectionRenderer
                rowData={rowData}
                rowSelection={rowSelection}
                handleCheckboxChange={handleCheckboxChange}
              /> */}
                {canRender("processName") && (
                  <ImageNameCellRenderer
                    cellKey="processName"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                    actionType="process"
                  />
                )}
                {siteConfigDetails.mode === 2 && canRender("subTitle") && (
                  <NameCellRenderer
                    cellKey="subTitle"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {canRender("processLogic") && (
                  <NameCellRenderer
                    cellKey="processLogic"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {siteConfigDetails.mode === 1 && canRender("subProcessLogic") && (
                  <NameCellRenderer
                    cellKey="subProcessLogic"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {siteConfigDetails.mode === 2 && canRender("surveyName") && (
                  <NameCellRenderer
                    cellKey="surveyName"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {canRender("inspectedBy") && (
                  <NameCellRenderer
                    cellKey="inspectedBy"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {canRender("createdDate") && (
                  <NameCellRenderer
                    cellKey="createdDate"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {isVerifiedRequired === 1 && (
                  <NameCellRenderer
                    cellKey="verifiedBy"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {isVerifiedRequired === 1 && (
                  <NameCellRenderer
                    cellKey="verifiedDate"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {canRender("verificationStatus") && (
                  <StatusNameCellRenderer
                    cellKey="verificationStatus"
                    selectedColumns={selectedColumns}
                    rowData={rowData}
                    handleClick={handleCellClicked}
                  />
                )}
                {
                  isDeleteOption == 1 &&
                  <MoreOptionsRenderer
                    rowData={rowData}
                    moreOptions={moreOptions}
                    isEditDisabled = {1}
                    selectedMoreOption={selectedMoreOption}
                  />
                }
                {/* {siteConfigDetails.isExportRequired === 1 && (
                  <DownloadRenderer
                  rowData={rowData}
                  moreOptions={moreOptions}
                  handleOpenInfo={handleOpenMoreInfo}
                  handleDownloadClick={() => handleDownloadClick(rowData)}
                  siteConfigDetails={siteConfigDetails}
                  isLoading={isLoading}
                />
                )} */}
                {/* <ExportRenderer
                  rowData={rowData}
                  moreOptions={moreOptions}
                  handleOpenInfo={handleOpenMoreInfo}
                  handleExportClick={() => handleExportClick(rowData)}
                  siteConfigDetails={siteConfigDetails}
                /> */}
              </tr>
            </Fragment>
          ))}
        </InfiniteScrollGrid>
      </div>
    </>
  );
}
export default ProcessGrid;
